import { render } from "./TagsInput.vue?vue&type=template&id=02cbfd3c&scoped=true"
import script from "./TagsInput.vue?vue&type=script&lang=js"
export * from "./TagsInput.vue?vue&type=script&lang=js"

import "./TagsInput.vue?vue&type=style&index=0&id=02cbfd3c&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02cbfd3c"]])

export default __exports__